module.exports = __webpack_public_path__ + "img/xslpewm.9bf182d2.png";